import { httpClient } from '@/api/http';

export interface ReferralUser {
  id: number;
  name: string;
  firstname: string;
  lastname: string;
  email: string;
  createdAt: string;
  sponsorId: string | null;
  referrerId: number | null;
  level: number;
  purchase: number;
  joinViaReferral: 'YES' | 'NO';
  downlinePurchaseAmount: number;
  rank: string;
}

export interface GetReferralUsersParams {
  skip?: number;
  take?: number;
  search?: string;
  level?: string;
  fromDate?: string;
  toDate?: string;
  referralFilter?: string;
}

export interface GetReferralUsersResponse {
  count: number;
  skip: number;
  take: number;
  data: ReferralUser[];
}

export interface DownlineStats {
  downlineCount: number;
  directSentL1: number;
  purchaseCountL1: number;
  purchaseAmountL1: number;
  purchaseCountAll: number;
  purchaseAmountAll: number;
}

export async function getReferralUsersListing(
  params?: GetReferralUsersParams
): Promise<GetReferralUsersResponse> {
  const { data } = await httpClient.get<GetReferralUsersResponse>(
    '/admin/referral/users-listing',
    { params }
  );
  return data;
}

export async function getDownlineStats(userId: number): Promise<DownlineStats> {
  const { data } = await httpClient.get<DownlineStats>(
    `/admin/referral/${userId}/downline-stats`
  );
  return data;
}
